import { rankingData } from '@/mocks/home';

const trendIcons: Record<string, { icon: string; color: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  down: { icon: 'ri-arrow-down-line', color: 'text-foreground-400' },
  stable: { icon: 'ri-subtract-line', color: 'text-foreground-400' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          热度排行
        </h2>
        <div className="flex flex-col gap-2">
          {rankingData.map((item) => {
            const trend = trendIcons[item.trend] || trendIcons.stable;
            return (
              <div
                key={item.id}
                className="flex items-center gap-4 p-4 rounded-lg bg-background-100 hover:bg-primary-50/30 transition-colors cursor-pointer group"
              >
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 text-sm font-heading ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <h3 className="text-sm font-medium text-foreground-900 whitespace-nowrap group-hover:text-primary-500 transition-colors">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.type}</span>
                  </div>
                  <p className="text-xs text-foreground-600 line-clamp-1">{item.desc}</p>
                </div>
                <div className="flex items-center gap-1.5 flex-shrink-0">
                  <span className="text-sm font-heading text-accent-500">{item.heat}</span>
                  <span className={`w-4 h-4 flex items-center justify-center ${trend.color}`}>
                    <i className={`${trend.icon} text-xs`}></i>
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}